document.addEventListener("DOMContentLoaded", function () {
  /* ===================== Utilities ===================== */
  const $  = (id) => document.getElementById(id);

  const getStepTwo       = () => $("stepTwo");
  const getStepTwoBtn    = () => $("cart--step-2-button");
  // tolerant getter for Step Two mirror
  const getSelProv1      = () =>
    document.getElementById("selected-provider") ||
    document.getElementById("selectedprovider") ||
    document.querySelector("[data-selected-provider]");
  const getSelProv2      = () => $("selected-provider2");
  const getWithProvBtn   = () => $("withProviderBtn");
  const getNewProvBtn    = () => $("newProviderBtn");
  const getEditCart      = () => $("editCart") || $("editcart"); 
  const getAffiliateCta  = () => $("affiliateCheckout") || $("affilateCheckout"); 
  const getCartItems     = () => $("cartItems");
  const getNoProvBtn     = () => $("withoutProvider");
  const getClinicInput   = () => $("clinic-input");
  const getClinicList    = () => $("clinic-results");
  const getProvHeading   = () => $("providerHeading");

  const forceShow = (el) => {
    if (!el) return;
    el.classList.remove("hidden");
    el.removeAttribute("hidden");
    el.style.removeProperty("display");
    el.style.removeProperty("visibility");
  };
  const forceHide = (el) => {
    if (!el) return;
    el.classList.add("hidden");
    el.setAttribute("hidden", "");
    el.style.setProperty("display", "none", "important");
    el.style.setProperty("visibility", "hidden", "important");
  };

  function waitForEl(selector, { timeout = 4000 } = {}) {
    return new Promise((resolve) => {
      const now = document.querySelector(selector);
      if (now) return resolve(now);
      const obs = new MutationObserver(() => {
        const el = document.querySelector(selector);
        if (el) { obs.disconnect(); resolve(el); }
      });
      obs.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => { obs.disconnect(); resolve(null); }, timeout);
    });
  }

  /* ===================== Redirect helper ===================== */
  if (sessionStorage.getItem("redirectToCheckout") === "true") {
    sessionStorage.removeItem("redirectToCheckout");
    const loader = $("checkout-loading-screen");
    if (loader) loader.classList.remove("hidden");
    setTimeout(() => { window.location.href = "/checkout"; }, 3000);
    return;
  }

  /* ===================== State ===================== */
  let clinics = [];
  let currentClinic = null; // single source of truth for selected clinic

  // Only treat URL/localStorage as "already chosen on load"
  const explicitScaRefNow = () =>
    new URLSearchParams(location.search).get("sca_ref") ||
    localStorage.getItem("sca_ref");

  const isStepTwoActive = () => {
    const st = getStepTwo();
    return st && !st.classList.contains("hidden");
  };
  const isClinicSearchActive = () => {
    const input = getClinicInput();
    const list  = getClinicList();
    const focused = input && document.activeElement === input;
    const open   = list && !list.classList.contains("hidden");
    return Boolean(focused || open);
  };

  /* ===================== Rendering ===================== */
  function clinicMarkup(clinic) {
    return `
      <h3 class="text-xxxl clinic-name">${clinic.name || ""}</h3>
      <div class="mt-2 phone-number"><p>${clinic.phone || ""}</p></div>
      <p class="address">${clinic.address || ""}&nbsp;${clinic.city || ""},&nbsp;${clinic.state || ""}&nbsp;${clinic.zip_code || ""}</p>
    `;
  }

  function updateMessageBar(clinic) {
    const bar = document.querySelector(".scaaf-message-bar");
    if (!bar || !clinic) return;

    // remove any old message first
    let msg = bar.querySelector(".scaaf-message-bar-content");
    if (!msg) {
      msg = document.createElement("p");
      msg.className = "scaaf-message-bar-content";
      bar.appendChild(msg);
    }
    msg.textContent = `You are shopping Hydrinity with ${clinic.name}`;
  }

  function renderSelectedProviderMirrors(clinic) {
    if (!clinic) return;
    const html = clinicMarkup(clinic);
    const sp1 = getSelProv1(); // Step Two box
    const sp2 = getSelProv2(); // Drawer box

    [sp1, sp2].forEach(host => {
      if (!host) return;
      host.innerHTML = html;
      host.classList.remove("hidden");
      host.setAttribute("data-sca-ref", clinic.sca_ref || "");
      host.setAttribute("data-preserve-children", "");
    });
  }

  async function ensureStepTwoMirrorRendered() {
    if (!currentClinic) return;
    let host = getSelProv1();
    if (host) {
      if (!host.innerHTML.trim()) renderSelectedProviderMirrors(currentClinic);
      return;
    }
    host = await waitForEl("#selected-provider, #selectedprovider, [data-selected-provider]");
    if (host && !host.innerHTML.trim()) renderSelectedProviderMirrors(currentClinic);
  }

  // Single source of truth for buttons/CTA visibility
  function syncUI() {
    const stepTwoBtn   = getStepTwoBtn();
    const affiliateCta = getAffiliateCta();
    const noProvBtn    = getNoProvBtn();
    const editCartBtn  = getEditCart();

    const haveExplicit = Boolean(explicitScaRefNow());
    const stepTwoOpen  = isStepTwoActive();

    // Rule: affiliateCheckout visible only if provider selected AND Step Two is hidden
    if (haveExplicit && !stepTwoOpen) forceShow(affiliateCta);
    else                              forceHide(affiliateCta);

    // Continue button hidden when Step Two is open, explicit provider exists, or searching
    if (stepTwoOpen || haveExplicit || isClinicSearchActive()) {
      forceHide(stepTwoBtn);
    } else {
      forceShow(stepTwoBtn);
    }

    // "Checkout without provider" only if no explicit provider
    if (haveExplicit) forceHide(noProvBtn);
    else              forceShow(noProvBtn);

    // Rule: #editcart visible only when Step Two is visible
    if (editCartBtn) {
      if (stepTwoOpen) forceShow(editCartBtn);
      else             forceHide(editCartBtn);
    }
  }

  /* ===================== Initial layout ===================== */
  (function initialLayout() {
    const cartItems = getCartItems();
    const stepTwo   = getStepTwo();

    if (explicitScaRefNow()) {
      // Provider known on load → skip Step Two
      forceHide(stepTwo);
      forceHide(getStepTwoBtn());
      // affiliate CTA will be shown by syncUI (since stepTwo hidden)
      // Ensure editcart is hidden because Step Two is hidden
      const ec = getEditCart(); if (ec) forceHide(ec);
      if (cartItems) cartItems.classList.add("min");
    } else {
      // No provider → allow opening Step Two
      forceShow(getStepTwoBtn());
      forceHide(getAffiliateCta());
      const ec = getEditCart(); if (ec) forceHide(ec);
    }

    [0, 120, 300, 800, 1500].forEach(ms => setTimeout(syncUI, ms));
  })();

  /* ===================== Event bindings ===================== */
  function bindStepTwoBtn() {
    const btn = getStepTwoBtn();
    if (!btn || btn.dataset.bound === "true") return;
    btn.dataset.bound = "true";
    if (!btn.getAttribute("type")) btn.setAttribute("type", "button");
    btn.addEventListener("click", async (e) => {
      e.preventDefault();
      const st = getStepTwo();
      if (st) st.classList.remove("hidden");
      const ec = getEditCart(); if (ec) forceShow(ec);
      forceHide(getStepTwoBtn());
      await ensureStepTwoMirrorRendered(); // ensure #selected-provider is filled
      st?.scrollIntoView({ behavior: "smooth" });
      syncUI();
    });
  }

  function bindNewProviderBtn() {
    const btn = getNewProvBtn();
    if (!btn || btn.dataset.bound === "true") return;
    btn.dataset.bound = "true";
    if (!btn.getAttribute("type")) btn.setAttribute("type", "button");
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      const show = (el) => { if (!el) return; el.classList.remove("hidden"); el.removeAttribute("hidden"); el.style.removeProperty("display"); el.style.removeProperty("visibility"); };
      const hide = (el) => { if (el) el.classList.add("hidden"); };
      document.querySelectorAll(".with-provider").forEach(show);
      show(getProvHeading());
      show(getClinicInput());
      hide(getSelProv1());
      hide(getNewProvBtn());
      hide(getWithProvBtn());
      syncUI();
    });
  }

  function revertToCart() {
    const st = getStepTwo();
    st?.classList.add("hidden");

    forceShow(getStepTwoBtn());
    const ec = getEditCart(); if (ec) forceHide(ec);

    const sp1 = getSelProv1();
    if (sp1) {
      sp1.classList.add("hidden");
      sp1.innerHTML = "";
      sp1.removeAttribute("data-sca-ref");
    }
    const sp2 = getSelProv2();
    if (sp2) {
      sp2.classList.add("hidden");
      sp2.innerHTML = "";
      sp2.removeAttribute("data-sca-ref");
    }

    getProvHeading()?.classList.remove("hidden");
    getClinicInput()?.classList.remove("hidden");
    getWithProvBtn()?.classList.add("hidden");
    getNewProvBtn()?.classList.add("hidden");
    getClinicList()?.classList.add("hidden");

    currentClinic = null;
    localStorage.removeItem("sca_ref");
    sessionStorage.removeItem("clinicStepContinued");

    const url = new URL(location.href);
    url.searchParams.delete("sca_ref");
    history.replaceState({}, "", url.pathname + (url.search ? "?" + url.searchParams.toString() : "") + url.hash);

    syncUI();
  }

  function bindEditCartBtn() {
    const btn = getEditCart();
    if (!btn || btn.dataset.bound === "true") return;
    btn.dataset.bound = "true";
    if (btn.tagName === "BUTTON" && !btn.getAttribute("type")) btn.setAttribute("type", "button");
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      // Rule: #editcart hides Step Two and shows Continue button
      const st = getStepTwo();
      if (st) st.classList.add("hidden");
      forceShow(getStepTwoBtn());
      forceHide(getEditCart());
      // Do NOT clear the provider on edit — just letting user go back to cart view
      syncUI();
    });
  }

  /*function bindWithProviderBtn() {
    const btn = getWithProvBtn();
    if (!btn || btn.dataset.bound === "true") return;
    btn.dataset.bound = "true";
    if (!btn.getAttribute("type")) btn.setAttribute("type", "button");
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (!currentClinic) return;

      localStorage.setItem("sca_ref", currentClinic.sca_ref);
      sessionStorage.setItem("clinicStepContinued", "true");
      sessionStorage.setItem("redirectToCheckout", "true");

      const cleanUrl = location.origin + location.pathname;
      history.replaceState({}, "", `${cleanUrl}?sca_ref=${currentClinic.sca_ref}`);

      window.location.reload();
    });
  }*/

  function bindWithProviderBtn() {
    const btn = getWithProvBtn();
    if (!btn || btn.dataset.bound === "true") return;
    btn.dataset.bound = "true";
    if (!btn.getAttribute("type")) btn.setAttribute("type", "button");

    btn.addEventListener("click", (e) => {
      e.preventDefault();
      if (!currentClinic) return;

      const ref = (currentClinic.sca_ref || "").trim();
      // Try to use clinic link *only if* it’s same-origin; otherwise use "/"
      const candidate = currentClinic.referral_link || currentClinic.custom_referral_link || "/";
      let landing = new URL("/", location.origin);
      try {
        const u = new URL(candidate, location.origin);
        if (u.origin === location.origin) {
          landing = u; // keep its path if same-origin
        }
      } catch {}

      // Ensure sca_ref is present and add auto-return to checkout
      if (ref) landing.searchParams.set("sca_ref", ref);
      landing.searchParams.set("sca_after", "/checkout");
      landing.searchParams.set("sca_delay", "2500"); // ms

      window.location.href = landing.toString();
    });
  }

  function displaySelectedClinic(clinic, fromLoad = false) {
    currentClinic = clinic;
    renderSelectedProviderMirrors(clinic);  // updates BOTH #selected-provider & #selected-provider2

    updateMessageBar(clinic); 

    // Adjust Step Two controls
    getProvHeading()?.classList.add("hidden");
    getClinicInput()?.classList.add("hidden");
    getWithProvBtn()?.classList.remove("hidden");
    getNewProvBtn()?.classList.remove("hidden");

    if (fromLoad) {
      // Provider existed at page load → skip Step Two
      const st = getStepTwo();
      if (st) st.classList.add("hidden");
      forceHide(getStepTwoBtn());
      // affiliate shown by syncUI because stepTwo hidden and provider explicit
      const ec = getEditCart(); if (ec) forceHide(ec);
    } else {
      // In-session pick → keep Step Two visible to complete the flow
      const st = getStepTwo();
      if (st) st.classList.remove("hidden");
      forceHide(getStepTwoBtn());
      // Do not show affiliate CTA yet; user should click "With Provider"
      const ec = getEditCart(); if (ec) forceShow(ec);
    }

    bindWithProviderBtn();
    bindNewProviderBtn();
    bindEditCartBtn();
    ensureStepTwoMirrorRendered(); // make sure Step Two mirror is populated
    syncUI();
  }

  function bindClinicSearch() {
    const input = getClinicInput();
    const list  = getClinicList();
    if (!input || !list || input.dataset.bound === "true") return;
    input.dataset.bound = "true";

    input.addEventListener("focus", syncUI);
    input.addEventListener("blur",  syncUI);

    input.addEventListener("input", function () {
      forceHide(getStepTwoBtn()); // hide while searching

      const q = input.value.trim().toLowerCase();
      list.innerHTML = "";
      if (!q || clinics.length === 0) {
        list.classList.add("hidden");
        syncUI();
        return;
      }

      const matches = clinics.filter(c =>
        ((c.name || "") + (c.address || "") + (c.zip_code || "")).toLowerCase().includes(q)
      );

      if (matches.length) {
        list.classList.remove("hidden");
        matches.forEach((clinic) => {
          const li = document.createElement("li");
          li.className = "p-4 border-b hover:bg-gray-100 cursor-pointer";
          li.innerHTML = `
            <p class="clinic-name font-medium">${clinic.name || ""}</p>
            <p class="opacity-50">${clinic.address || ""}&nbsp;${clinic.city || ""},&nbsp;${clinic.state || ""}&nbsp;${clinic.zip_code || ""}</p>
          `;
          li.addEventListener("click", () => {
            displaySelectedClinic(clinic); // fromLoad = false
            list.classList.add("hidden");
            syncUI();
          });
          list.appendChild(li);
        });
      } else {
        list.innerHTML = "<li class='p-2'>No clinics found.</li>";
        list.classList.remove("hidden");
      }

      syncUI();
    });

    document.addEventListener("click", function (e) {
      if (!input.contains(e.target) && !getClinicList().contains(e.target)) {
        getClinicList().classList.add("hidden");
        syncUI();
      }
    });
  }

  /* ===================== Boot: fetch clinics, then bind ===================== */
  fetch("https://shopify-affiliate-proxy.vercel.app/api/affiliates?token=pk_wjpmKncKyzsp53txbsmhRrYUbEQJCZnO")
  .then(res => res.json())
  .then(data => {
    if (Array.isArray(data)) {
      clinics = data;
    } else if (Array.isArray(data.affiliates)) {
      clinics = data.affiliates;
    } else if (Array.isArray(data.data)) {
      clinics = data.data;
    } else {
      console.warn("Unexpected affiliates payload shape:", data);
      clinics = [];
    }

    /*console.log("Clinics loaded:", clinics);*/

    const ref = new URLSearchParams(location.search).get("sca_ref") || localStorage.getItem("sca_ref");
    if (ref && clinics.length) {
      const found = clinics.find(c => String(c.sca_ref) === String(ref));
      if (found) displaySelectedClinic(found, true); // fromLoad = true
    }

    syncUI();
  })
  .catch((err) => {
    console.error("Failed to fetch clinics:", err);
    syncUI();
  });

  // Initial bindings
  bindStepTwoBtn();
  bindNewProviderBtn();
  bindEditCartBtn();
  bindWithProviderBtn();
  bindClinicSearch();

  // Optional: keep mirrors in sync if other scripts broadcast these
  document.addEventListener("drawer:reloaded", () => { if (currentClinic) renderSelectedProviderMirrors(currentClinic); });
  document.addEventListener("cart:refresh",    () => { if (currentClinic) renderSelectedProviderMirrors(currentClinic); });

  // Re-bind after theme/ATC re-renders
  const observer = new MutationObserver(() => {
    bindStepTwoBtn();
    bindNewProviderBtn();
    bindEditCartBtn();
    bindWithProviderBtn();
    bindClinicSearch();
    ensureStepTwoMirrorRendered();
    syncUI();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Final enforcement passes
  setTimeout(syncUI, 0);
  setTimeout(syncUI, 300);
  setTimeout(syncUI, 800);


  // if user enter site via affiliate link, select affiliate in cart

  (() => {
  const CONFIG = {
    endpoint: 'https://shopify-affiliate-proxy.vercel.app/api/affiliates?token=pk_wjpmKncKyzsp53txbsmhRrYUbEQJCZnO',
    cookieName: 'sca_ref',
    cookieDays: 30,
    providerSelectors: '#selected-provider, #selectedprovider, [data-selected-provider], #selected-provider2',
    stepTwoSelector: '#stepTwo',
    stepTwoBtnId: 'cart--step-2-button',
    editCartId: 'editCart',
    editCartIdAlt: 'editcart',
    affiliateCtaId: 'affiliateCheckout',
    affiliateCtaIdAlt: 'affilateCheckout', // typo-safe
    cartItemsId: 'cartItems'
  };

  const $id = (x) => document.getElementById(x);
  const q  = (sel) => document.querySelector(sel);
  const qa = (sel) => Array.from(document.querySelectorAll(sel));
  const log = (...a)=>console.log('%c[Aff-AutoPresent]', 'color:#2563eb;font-weight:600', ...a);
  const warn = (...a)=>console.warn('%c[Aff-AutoPresent]', 'color:#b45309;font-weight:600', ...a);

  // --- ref helpers ---
  const baseRef = (v) => {
    const s = String(v||'').trim();
    const m = s.match(/^\d+/);
    if (m) return m[0];
    return s.split('.')[0].split(/[^A-Za-z0-9_-]/)[0];
  };
  const getCookie = (name) => {
    const n = encodeURIComponent(name)+'=';
    const s = document.cookie.split(';').map(s=>s.trim()).find(s=>s.startsWith(n));
    return s ? decodeURIComponent(s.slice(n.length)) : null;
  };
  const setCookie = (name, value, days) => {
    const maxAge = Math.max(1, (days|0)) * 86400;
    let c = `${encodeURIComponent(name)}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax`;
    if (location.protocol === 'https:') c += '; Secure';
    document.cookie = c;
  };
  const getUrlParam = (k) =>
    new URLSearchParams(location.search).get(k) ||
    new URLSearchParams(location.hash.replace(/^#\?/, '')).get(k);

  const forceShow = (el) => { if (!el) return;
    el.classList.remove('hidden'); el.removeAttribute('hidden');
    el.style.removeProperty('display'); el.style.removeProperty('visibility');
  };
  const forceHide = (el) => { if (!el) return;
    el.classList.add('hidden'); el.setAttribute('hidden','');
    el.style.setProperty('display','none','important');
    el.style.setProperty('visibility','hidden','important');
  };

  // --- ui rendering ---
  const renderProviderMirrors = (aff, fullRef) => {
    const nodes = qa(CONFIG.providerSelectors);
    if (!nodes.length) return;
    const html = `
      <h3 class="text-xxxl clinic-name">${aff.name || ''}</h3>
      <div class="mt-2 phone-number"><p>${aff.phone || ''}</p></div>
      <p class="address">${aff.address || ''}&nbsp;${aff.city || ''},&nbsp;${aff.state || ''}&nbsp;${aff.zip_code || ''}</p>
    `;
    nodes.forEach(el => {
      el.innerHTML = html;
      el.classList.remove('hidden');
      el.setAttribute('data-sca-ref', fullRef);
      el.setAttribute('data-preserve-children', '');
    });
  };

  /*const updateMessageBar = (aff) => {
    const bar = q('.scaaf-message-bar');
    if (!bar) return;
    let msg = bar.querySelector('.scaaf-message-bar-content');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'scaaf-message-bar-content';
      bar.appendChild(msg);
    }
    msg.textContent = `You are shopping Hydrinity with ${aff.name}`;
  };*/

  // Present cart as if provider already selected
  const presentCartAsSelected = () => {
    const stepTwo = q(CONFIG.stepTwoSelector);
    const stepTwoBtn = $id(CONFIG.stepTwoBtnId);
    const editCart = $id(CONFIG.editCartId) || $id(CONFIG.editCartIdAlt);
    const affiliateCta = $id(CONFIG.affiliateCtaId) || $id(CONFIG.affiliateCtaIdAlt);
    const cartItems = $id(CONFIG.cartItemsId);

    forceHide(stepTwo);
    forceHide(stepTwoBtn);
    forceHide(editCart);
    forceShow(affiliateCta);
    if (cartItems) cartItems.classList.add('min');

    // If your script exposes syncUI(), use it to keep rules consistent.
    if (typeof window.syncUI === 'function') {
      try { window.syncUI(); } catch(_) {}
    }
  };

  // --- main ---
  (async function boot() {
    const fromUrl  = getUrlParam('sca_ref');
    const fromLS   = localStorage.getItem('sca_ref');
    const fromCook = getCookie(CONFIG.cookieName);
    const fullRef  = (fromUrl || fromLS || fromCook || '').trim();
    const base     = baseRef(fullRef);

    if (!base) { log('No sca_ref present. Nothing to do.'); return; }

    // Load affiliates and match by base id
    let list = [];
    try {
      const res = await fetch(CONFIG.endpoint, { cache: 'no-store', credentials: 'omit' });
      list = (await res.json()) || [];
    } catch (e) {
      warn('Failed to load affiliates.json, showing cart UI anyway.', e);
      // We will still present the cart, just without mirror data.
      presentCartAsSelected();
      return;
    }

    const hit = list.find(a => String(baseRef(a.sca_ref)) === String(base));
    if (!hit) {
      warn('No affiliate matched base', base, '— storing full ref and presenting cart anyway.');
      // Store full ref so flow continues even if JSON doesn’t have it yet
      localStorage.setItem('sca_ref', fullRef);
      setCookie(CONFIG.cookieName, fullRef, CONFIG.cookieDays);
      presentCartAsSelected();
      return;
    }

    // Store the full ref (keeps suffixes)
    localStorage.setItem('sca_ref', fullRef);
    setCookie(CONFIG.cookieName, fullRef, CONFIG.cookieDays);

    // Render provider boxes + message bar, then present the cart
    renderProviderMirrors(hit, fullRef);
    updateMessageBar(hit);
    presentCartAsSelected();

    // Fire the same event your flow listens to (if any)
    window.dispatchEvent(new CustomEvent('affiliate:capture', {
      detail: { sca_ref_full: fullRef, sca_ref_base: base, affiliate: hit }
    }));

    log('Presented cart as selected provider →', hit.name, 'ref:', fullRef, '(base:', base + ')');
  })();
})();
});

(function bounceBackToCheckout() {
  const qs = new URLSearchParams(location.search);
  const next  = qs.get("sca_after");                
  if (!next) return;

  const delay = Math.max(100, parseInt(qs.get("sca_delay"), 10) || 2500);

  // Optional: show your existing overlay while waiting
  const overlay = document.getElementById("checkout-loading-screen");
  if (overlay) overlay.classList.remove("hidden");

  // Avoid redirect loops if we're already at the target
  const target = new URL(next, location.origin);
  const alreadyThere =
    location.origin + location.pathname === target.origin + target.pathname;

  if (alreadyThere) return;

  setTimeout(() => {
    // Clean the URL so refresh/back doesn't re-trigger the bounce
    qs.delete("sca_after");
    qs.delete("sca_delay");
    const clean = location.pathname + (qs.toString() ? "?" + qs.toString() : "") + location.hash;
    history.replaceState({}, "", clean);

    // Head to checkout 
    window.location.href = target.toString();
  }, delay);
})();


/*fetch("https://shopify-affiliate-proxy.vercel.app/api/affiliates?token=pk_wjpmKncKyzsp53txbsmhRrYUbEQJCZnO", {
  method: "GET",
  mode: "cors",
})
.then(r => r.json())
.then(console.log)
.catch(console.error);
*/

